import React from "react";

import { Icons } from "components";

import { useLockBodyScroll } from "hooks";
import * as S from "./styles";

export type LoaderProps = {
  message?: string;
};

export const Loader = ({ message }: LoaderProps) => {
  useLockBodyScroll();

  return (
    <S.Container>
      <S.Content>
        <S.Icon>
          <Icons.Loader />
        </S.Icon>

        {!!message && <S.Message>{message}</S.Message>}
      </S.Content>
    </S.Container>
  );
};
